import { render } from "./NamingConventionSeverityOverridesField.vue?vue&type=template&id=1e1a7677&scoped=true"
import script from "./NamingConventionSeverityOverridesField.vue?vue&type=script&lang=js"
export * from "./NamingConventionSeverityOverridesField.vue?vue&type=script&lang=js"

import "./NamingConventionSeverityOverridesField.vue?vue&type=style&index=0&id=1e1a7677&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1a7677"]])

export default __exports__